import gql from 'not-graphql-tag';

export const getAccountDetails = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      accountNumber
      encryptedAccountNumber
      encryptedPersonId
      description
      isDefault
      isActive
      accountType
      relationType
      mainCustomerName
      coCustomerNames
      isLoggedInUserOnAccount
      serviceAddresses {
        addressLine1
        addressLine2
        city
        state
        postal
      }
      isSummaryBillAccount
      billInfo {
        amountDue
        dueDate
        lastPaymentDate
        lastPaymentAmount
        isAccountPayable
        isNewAccount
        oneTimeFuturePaymentScheduled
        multipleFuturePaymentsScheduled
        enrolledInTPA
        billDetails {
          encryptedBillId
          downloadBillUrl
          billStatus
          billDate
          dueDate
          amountDue
          previousBalance
          totalAdjustments
          totalCurrentCharges
          totalBalanceAfterBill
          hasBills
          kwh
          billingPeriodStartDate
          billingPeriodEndDate
        }
      }
      autoPay {
        isEnrolled
        startDate
      }
      paymentEligibility {
        isCashOnly
        isNonBillableNoBalance
      }
      pendingCharges {
        totalPendingCharges
      }
      preferredDueDate {
        dueDate {
          preferredDueDate
          status
          effectiveDate
        }
      }
      isPaperlessBillEnrolled {
        result
      }
      equalpay {
        paymentPlanType
      }
      pendingDisconnect {
        isPendingDisconnect
      }
      serviceConnectivity {
        isEligibleForReconnect
        isDisconnected
        isReconnectInProgress
        disconnectionDate
      }
      premiseInfo {
        saDetails {
          encryptedSAId
        }
      }
    }
  }
`;
export const getIQBDStatus = gql`
  query getIQBDStatus($iqbdParams: IqbdParams!, $params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      accountNumber
      IQBDStatus(IqbdParams: $iqbdParams) {
        isEnrolled
        isExpired
        isSameAccountEnrolled
        discountTier
        expirationDate
      }
    }
  }
`;
export const getAccountDetailsForPaymentHistory = gql`
  query getAccountDetails(
    $params: AccountDetailParams!
    $paymentHistoryParams: PaymentHistoryParams!
  ) {
    getAccountDetails(params: $params) {
      accountNumber
      mainCustomerName
      coCustomerNames
      premiseInfo {
        addressLine1
        addressLine2
        city
        state
        postal
      }
      isSummaryBillAccount
      billInfo {
        billDetails {
          encryptedBillId
          downloadBillUrl
          billStatus
          billDate
          dueDate
          amountDue
          previousBalance
          totalAdjustments
          totalCurrentCharges
          totalBalanceAfterBill
          hasBills
          kwh
          billingPeriodStartDate
          billingPeriodEndDate
        }
        amountDue
        dueDate
        lastPaymentDate
        lastPaymentAmount
        isAccountPayable
        isNewAccount
        oneTimeFuturePaymentScheduled
        multipleFuturePaymentsScheduled
        enrolledInTPA
      }
      autoPay {
        isEnrolled
        startDate
      }
      pendingDisconnect {
        isPendingDisconnect
      }
      serviceConnectivity {
        isEligibleForReconnect
        isDisconnected
        isReconnectInProgress
      }
      paymentHistory(paymentHistoryParams: $paymentHistoryParams) {
        paymentHistoryDetails {
          date
          amountPaid
          type
        }
        totalDetailsRecords
      }
      viewBillAverageTemperature {
        temperatureSource
        currentBillingPeriod {
          date
          averageTemperature
          totalCost
          totalKwh
        }
        previousBillingPeriod {
          date
          averageTemperature
          totalCost
          totalKwh
        }
      }
      viewBillMonthUsage {
        usages {
          monthName
          year
          totalKwh
        }
      }
      pgeEnergyTracker {
        energyTrackerInfo {
          showEnergyTracker
          identifiers
        }
        billableAccountDetails {
          isAccountBillable
          isServiceDesignationElectric
        }
      }
      equalpay {
        paymentPlanType
      }
    }
  }
`;

export const getBillingOptionsDetails = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      accountNumber
      accountType
      preferredDueDate {
        dueDate {
          preferredDueDate
          status
          effectiveDate
        }
      }
      isPaperlessBillEnrolled {
        result
      }
    }
  }
`;
export const getOnPremDetails = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      accountNumber
      peaktimeRebate {
        hasActiveSA
        peakTimeRebateEnrollmentStatus
        hasRebates
      }
      renewableEnrollment {
        renewableEnrollmentStatus
      }
      timeOfDayInfo {
        enrollmentStatus
      }
    }
  }
`;

export const getOnPremDetailsWithOutageCause = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      accountNumber
      premiseInfo {
        servicePointDetails {
          outageInfo {
            cause
          }
        }
        saDetails {
          startDate
        }
      }
    }
  }
`;

export const getEnergyTrackerData = gql`
  query getEnergyTrackerData($params: EnergyTrackerDataParams) {
    getEnergyTrackerData(params: $params) {
      detailsAvailable
      hasMoreThan15DaysOfData
      details {
        billingCycleDay
        numberOfBillingDays
        billToDateAmount
        minProjectedAmount
        maxProjectedAmount
      }
      currentBillingPeriod {
        totalKwh
      }
      previousBillingPeriod {
        totalKwh
      }
    }
  }
`;
export const getEnergyTrackerUserInfo = gql`
  query getEnergyTrackerUserInfo($params: String) {
    getEnergyTrackerUserInfo(encryptedAccountNumber: $params) {
      mainAccountPersonId
      premiseIds
    }
  }
`;

export const getPgeEnergyTrackerData = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      pgeEnergyTracker {
        energyTrackerInfo {
          showEnergyTracker
          identifiers
          serviceProvider
        }
        billableAccountDetails {
          isAccountBillable
          isServiceDesignationElectric
        }
      }
    }
  }
`;

export const getSmartThermostatEnrollmentStatusQuery = gql`
  query getSmartThermostatEnrollmentStatus(
    $payload: SmartThermostatEnrollmentStatusParams!
  ) {
    getSmartThermostatEnrollmentStatus(payload: $payload) {
      smartThermostatEnrollmentStatus
    }
  }
`;

export const getAccountDetailsForOutages = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      premiseInfo {
        servicePointDetails {
          encryptedServicePointId

          outageInfo {
            isReported
            totalReports
            crewDispatchStatus
            callbackPhone
            estimatedTimeOn
            estimatedTimeOut
            hasKnownOutage
            isDueToStorm
            callbackRequested
            registeredPhone
            isReported
            customersAffected
            cause
            eventStatus
          }
          meter {
            status
          }
        }
      }
    }
  }
`;
